import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const { borderRadiusFull } = theme();
const style = () => {
    return StyleSheet.create({
        container: {
            flex: 1,
        },
        iconContainer: {
            right: 0,
            top: 0,
        },
        image: {
            borderRadius: borderRadiusFull,
        },
        imageContainer: {
            borderRadius: borderRadiusFull,
        },
    });
};
export { style };
